<template>
<div class="chapter">
<div class="inner_page">
<div class="fm">
<h2 class="fmtitle"><span class="bold">Acknowledgements</span></h2>
<p class="noindent"><em class="italic">I would like to say a big thank you to LoveCrochet. com for providing all the yarn; May, Katie and all the wonderful people at Search Press for making this book possible; my sister, Kate, for her honesty and great eye for detail; Annette, Arielle, Suzanne and Stephie for their amazing help and all my other family and friends for their constant support and encouragement.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?530a4aac